import MainHome from "../components/Home"
import SellerHome from "../components/SellerHome"
import AdminHome from "../components/AdminHome";
import { useDispatch } from "react-redux";
import { setIsSellerSubdomain, setIsAdminSubdomain } from "../store/CoreSlice";
import { useEffect } from "react";
import { MixpanelTracking } from "../MixPanel";
import helpers from "../utils/helpers";
import urls from "../constants/api-endpoints";
import { AxiosPromise } from "../utils/axios";

export async function getServerSideProps(context : any) {
	const subdomain = context.req.headers.host.split('.')[0];

	const SELLER_SUBDOMAIN_NAME : any = process.env.NEXT_PUBLIC_SELLER_SUBDOMAIN_NAME	
	const ADMIN_SUBDOMAIN_NAME : any = process.env.NEXT_PUBLIC_ADMIN_SUBDOMAIN_NAME

	if(subdomain === SELLER_SUBDOMAIN_NAME || subdomain === ADMIN_SUBDOMAIN_NAME) {
		const token = context.req.cookies;
		const accessToken = token.accessToken;
		if(accessToken) {
			return {
				redirect: {
					permanent: false,
					destination: subdomain === SELLER_SUBDOMAIN_NAME ? "/dashboard" : "/support/chat",
				},
			}
		}
	}

	return {
		props: {
			subdomain
		}
	};
}

function Home({ subdomain } : any) {
	const SELLER_SUBDOMAIN_NAME : any = process.env.NEXT_PUBLIC_SELLER_SUBDOMAIN_NAME	
	const ADMIN_SUBDOMAIN_NAME : any = process.env.NEXT_PUBLIC_ADMIN_SUBDOMAIN_NAME

	const dispatch = useDispatch();

	useEffect(() => {
		MixpanelTracking.getInstance().pageViewed({});

		if(subdomain === SELLER_SUBDOMAIN_NAME) {
			dispatch(setIsAdminSubdomain(false));
			dispatch(setIsSellerSubdomain(true));
		}
		else if(subdomain === ADMIN_SUBDOMAIN_NAME) {
			dispatch(setIsAdminSubdomain(true));
			dispatch(setIsSellerSubdomain(false));
		}
		else {
			dispatch(setIsAdminSubdomain(false));
			dispatch(setIsSellerSubdomain(false));
		}
	}, [])

	if(subdomain === SELLER_SUBDOMAIN_NAME) 
		return <SellerHome />
	else if(subdomain === ADMIN_SUBDOMAIN_NAME)
		return <AdminHome />
	return <MainHome />
}

export default Home